import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ThemeAssetComponent } from '@partners/themes';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
  selector: 'confirm-button',
  standalone: true,
  template: `
    <button mat-button [disabled]="disabled" [type]="type" (click)="onClick($event)">
      <ng-container *ngIf="isConfirmed">
        <theme-asset [loadViaHttp]="iconViaHttp()" [asset]="confirmIconName" [size]="iconSize()"></theme-asset>
      </ng-container>
      <ng-container *ngIf="iconName && !isConfirmed">
        <theme-asset [asset]="iconName()" [size]="iconSize()"></theme-asset>
      </ng-container>
      <ng-content></ng-content>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'button--confirm'
  },
  exportAs: 'confirmButton',
  imports: [NgIf, MatButtonModule, ThemeAssetComponent]
})
export class ConfirmButtonComponent extends BaseButtonComponent {
  @Input()
  @HostBinding('class.confirmed')
  isConfirmed: boolean = false;

  @Input()
  confirmIconName: string = 'filled-check-icon';

  iconViaHttp = input<boolean>(false);

  constructor() {
    super();
  }

  onClick(event: MouseEvent | TouchEvent) {
    event.stopPropagation();
    event.preventDefault();

    this.click.emit({ event: event, context: this.context });
    this.changeDetector.markForCheck();
  }
}
